import {StyledText, StyledTextList, StyledTextVideo} from "../../contenful/types";
import * as React from "react";
import {StyledTextComponent} from "./HeroBannerTwoColumnsComponent";
import {useEffect, useRef, useState} from "react";

interface Props {
    section : StyledTextList;
    mobile : boolean;
    loggedIn? : boolean;
}
export const StyledTextVideoComponent = (props : { video : StyledTextVideo}) => {
    const [playing, setPlaying] = useState(false);
    const video = useRef<HTMLVideoElement>(null);
    useEffect(()=> {
        const listener = ()=> {
            if(video?.current) {
                setPlaying(true);
                video.current.controls = true;
            }
        };
        video?.current?.addEventListener('click',listener, false)
        return () => {
            video.current?.removeEventListener('click', listener);
        }
    },[])
    const play = () => {
        if(video?.current) {
            setPlaying(true);
            video.current.controls = true;
            video?.current?.play?.();
        }
    }
    return (
        <div className={props.video.cssClass}>
            {!playing && (
                <div className={"play-video-container"}>
                    <a className={"play-video-button"} onClick={play}></a>
                </div>
            )}
            <video ref={video} controls={false} poster={props.video.poster?.fields.file?.url ?? ''}>
                <source src={props.video?.video?.fields?.file?.url}/>
            </video>
        </div>
    )
}
export const StyledTextListComponent = (props : Props) => {
    return (
        <>
            <div className={`styled-text-list ${(props.section.cssClassName ?? "")}`}>
                <div className={"container"}>
                    {props.section.title && (
                        <div className={"row title-row"}>
                            <h4>{props.section.title}</h4>
                        </div>
                    )}
                    <div className={"row"}>

                        {props.section.styledTexts?.filter(s => !!s).map((s : StyledText|StyledTextVideo) => {
                            if((s as StyledTextVideo).video) {
                                return <StyledTextVideoComponent video={s as StyledTextVideo}/>
                            }
                            return (
                                <StyledTextComponent st={s} key={s._id} loggedIn={props.loggedIn}/>
                            )
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}